import { Box, Typography } from "@mui/material";
import { nawyTheme } from "@/styles/nawy-theme/nawy-theme";
import useGenerateQrCode from "@/modules/lead-page/hooks/lead-info/lead-actions/generate-qr-code.hook";
import QrCodePreviewModal from "./qr-code-preview-modal";

export const GenerateQrCode = () => {
  const {
    onPreviewQrCode,
    onRegenerate,
    onSend,
    isLoading,
    isModalOpen,
    previewData,
    isRegenerating,
    isSending,
    closeModal,
  } = useGenerateQrCode();

  return (
    <>
      <Box
        sx={{
          display: "flex",
          gap: nawyTheme.nawy.spacing.xs,
          padding: nawyTheme.nawy.spacing.xs,
          alignItems: "center",
          width: "100%",
          height: "100%",
          cursor: isLoading ? "wait" : "pointer",
          opacity: isLoading ? 0.6 : 1,
          ":hover": {
            backgroundColor: nawyTheme.nawy.colors.semantic.layer.secondary,
          },
        }}
        onClick={onPreviewQrCode}
      >
        <Typography
          sx={{
            color: nawyTheme.nawy.colors.semantic.text.primary,
            ...nawyTheme.nawy.typography.english.variants.body.md.regular,
          }}
        >
          Generate QR Code
        </Typography>
      </Box>

      <QrCodePreviewModal
        open={isModalOpen}
        onClose={closeModal}
        data={previewData}
        onRegenerate={onRegenerate}
        onSend={onSend}
        isRegenerating={isRegenerating}
        isSending={isSending}
      />
    </>
  );
};
